import React from 'react';
import SummaryCards from './children/SummaryCards';
import BenchmarkBarChart from './children/BenchmarkBarChart';
import BenchmarkHeatmap from './children/BenchmarkHeatmap';
import KeyTakeAways from './children/KeyTakeAways';
import RatersResponseTable from './children/RatersResponseTable';
import SelfVsOtherPerception from './children/SelfVsOtherPerception';
import AlignmentInsights from './children/AlignmentInsights';
import LimitedVisibility from './children/LimitedVisibility';
import SampleComments from './children/SampleComments';
import TrendChartWrapper from './children/TrendChartWrapper';

// Pure layout — each section gates its own loading/empty state internally (via
// AsyncSection keyed on the slice it already consumes), so this wrapper reads
// no API slice and never re-renders when a section's API resolves. The one
// thing it does read is the trend toggle, which swaps the whole list for the
// comparison-mode one: those sections answer "what changed since last time?",
// which is a different question from the single-round sections below.
const ChartWrapper = (props) => {

    if (props.isTrendComparison) return <TrendChartWrapper />;

    return (
        <>
            <SummaryCards />
            <RatersResponseTable />
            <BenchmarkBarChart />
            <KeyTakeAways />
            <BenchmarkHeatmap />
            <SelfVsOtherPerception />
            <AlignmentInsights />
            <LimitedVisibility />
            <SampleComments />
        </>
    );
};

export default ChartWrapper;
